import { useStructureContext } from "../../../../context/StructureContext";
import { headerRecords } from "../../../../data/admin";
import StdTable from "../StdTable";
import { useMainContext } from "../../../../context/MainContext";
import { filterValues } from "./filterValues";

export default function RecordsBox() {
  const { type, searchValues, section, printArea } = useStructureContext();
  const { openRecordInfo } = useMainContext();

  return "FECHIS" in searchValues[section.id] ? (
    <div ref={printArea} className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerRecords}
        data={
          "results" in searchValues[section.id] &&
          Array.isArray(searchValues[section.id].results)
            ? filterValues(searchValues[section.id])
            : []
        }
        onDoubleClick={openRecordInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
